import {CircleAlert,LoaderCircle} from 'lucide-react';

export interface CapacityRetryPresentation {
  id:string;
  nativeThreadId:string;
  turnId:string;
  phase:'waiting'|'retrying'|'exhausted';
  retryCount:number;
  maxRetries:number;
}

export function CapacityRetryNotice({state,retrying=false,disabled=false,error='',onRetry}:{state:CapacityRetryPresentation;retrying?:boolean;disabled?:boolean;error?:string;onRetry:()=>void}){
  const exhausted=state.phase==='exhausted';
  return <div className="chat-capacity-notice" role={exhausted?'alert':'status'} aria-live="polite" aria-atomic="true" data-capacity-id={state.id} data-native-thread-id={state.nativeThreadId} data-turn-id={state.turnId}>
    <CircleAlert className="chat-capacity-icon" size={23} strokeWidth={1.9} aria-hidden="true"/>
    <div className="chat-capacity-content">
      <span>{exhausted?'模型当前繁忙，自动重试已达上限':'模型当前繁忙，请稍后再试或切换模型。'}</span>
      {!exhausted&&<span className="chat-capacity-progress">{state.retryCount>0?`正在重试 · ${state.retryCount}/${state.maxRetries}`:'正在重试…'}</span>}
      {error&&<span className="chat-capacity-action-error">{error}</span>}
    </div>
    {exhausted&&<button type="button" className="chat-capacity-retry" disabled={retrying||disabled} onClick={onRetry}>{retrying?<><LoaderCircle size={16} className="spin" aria-hidden="true"/>正在重试…</>:'重试'}</button>}
  </div>;
}
